module.exports = __webpack_public_path__ + "static/media/login.50e0b7ff.mp3";